import Canvas from "./components/Canvas";
import Features from "./components/Features";
import { Header } from "./components/Header";
import { LazyShow } from "./components/LazyShow";
import { MainHero } from "./components/MainHero";
import { MainHeroImage } from "./components/MainHeroImage";
import { Product } from "./components/Product";
import { SheetMetalCarousel } from "./components/SheetMetalCarousel";
import { MapComp as Map } from "./components/Map";
import { Footer } from "./components/Footer";


export function App() {
  return (
    <div className={`bg-background grid gap-y-16`}>
      <Header />
      <div className={`relative`}>
        <div className="max-w-7xl mx-auto">
          <div
            className={`relative z-10 pb-8 sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32`}
          >
            <MainHero />
          </div>
        </div>
        <MainHeroImage />
      </div>
      <Canvas />
      <LazyShow>
        <Product />
        <Canvas />
      </LazyShow>
      <LazyShow>
        <SheetMetalCarousel />
        <Canvas />
      </LazyShow>
      <LazyShow>
        <Features />
        <Canvas />
      </LazyShow>
      <LazyShow>
        <Map />
      </LazyShow>
      <LazyShow>
        <Footer />
      </LazyShow>

    </div>
  );
}
